import React from "react";

import { GroupBase } from "react-select";

import { Dropdown, DropdownProps } from "../../controls";
import FieldError from "../FieldError";
import FieldLabel from "../FieldLabel";
import FieldLayout from "../FieldLayout";

type Props<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
> = DropdownProps<Option, IsMulti, Group> & {
  label: React.ReactNode;
  name: string;
  showError?: boolean;
  error?: React.ReactNode;
  size?: "small" | "medium";
};

export default function FormDropdown<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
  const {
    name,
    label,
    error,
    showError = false,
    size = "medium",
    ...dropdownProps
  } = props;

  return (
    <FieldLayout showError={showError}>
      {{
        label: <FieldLabel htmlFor={name}>{label}</FieldLabel>,
        field: (
          <Dropdown
            id={name}
            inputId={name}
            aria-labelledby={name}
            name={name}
            size={size}
            error={showError}
            {...dropdownProps}
          />
        ),
        error: <FieldError>{error}</FieldError>
      }}
    </FieldLayout>
  );
}
